import { InvoiceState } from '@/store/types';

const stateBuilder = (): InvoiceState => {
  return {
    invoice: {
      invoiceNumber: 0,
      epcisHref: '',
      vendor: {
        id: 0,
        name: '',
        email: '',
        address: {
          addressLine1: '',
          addressLine2: '',
          city: '',
          state: '',
          zipCode: 0,
          country: '',
        },
      },
      billTo: {
        id: 0,
        name: '',
        email: '',
        address: {
          addressLine1: '',
          addressLine2: '',
          city: '',
          state: '',
          zipCode: 0,
          country: '',
        },
      },
      shipTo: {
        id: 0,
        name: '',
        email: '',
        address: {
          addressLine1: '',
          addressLine2: '',
          city: '',
          state: '',
          zipCode: 0,
          country: '',
        },
      },
      date: new Date(),
      salesRep: '',
      reference: '',
      shippingCost: 0,
      discount: 0,
      salesTax: 0,
      total: 0,
      items: [],
    },
    invoicesList: [],
    search: '',
  };
};

const state = stateBuilder;

export default state;
